import audioVideoAdController from '../ads/controllers/audioVideoAdController';
import displayAdController from '../ads/controllers/display/displayAdController';
import fallbackAdsController from '../ads/controllers/fallbackAdsController';
import { MediumTypes, Networks } from './constants';
export default function (formatDefinition) {
    let adTypeController = null;
    if (!formatDefinition) {
        return adTypeController;
    }
    switch (formatDefinition.medium) {
        case MediumTypes.audio:
        case MediumTypes.video: {
            adTypeController = audioVideoAdController;
            break;
        }
        case MediumTypes.display: {
            adTypeController = displayAdController;
            break;
        }
        case Networks.fallback: {
            adTypeController = fallbackAdsController;
            break;
        }
        default:
    }
    return adTypeController;
}
